<template>
	<div class="service">
		<managing-section :isTable="true">
			<template slot="infoSection">
				<div class="section__info__left">등록: {{ total }}건</div>
			</template>
			<table class="table-main">
				<thead>
					<tr>
						<th>번호</th>
						<th>등록일</th>
						<th>구분</th>
						<th>내용</th>
						<th>상태</th>
						<th>시작일</th>
						<th>종료일</th>
						<th>관리자명</th>
						<th>수정</th>
						<th>삭제</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="list in list" :key="list.id">
						<td>{{ list.id }}</td>
						<td>{{ list.createdDate }}</td>
						<td>
							{{ list.type === 'SERVICE' && '글로우픽 웹사이트' }}
						</td>
						<td>{{ list.content }}</td>
						<td>{{ status[list.status] }}</td>
						<td>{{ list.startDate }}</td>
						<td>{{ list.endDate }}</td>
						<td>{{ list.nickName }}</td>
						<td>
							<button
								type="button"
								class="btn blue"
								@click="modifyItem(list.id)"
							>
								수정
							</button>
						</td>
						<td>
							<button
								type="button"
								class="btn red"
								@click="deleteItem(list.id)"
							>
								삭제
							</button>
						</td>
					</tr>
				</tbody>
			</table>
		</managing-section>
	</div>
</template>
<script>
	import ManagingSection from '../../components/layout/ManagingSection.vue';
	import moment from 'moment';

	export default {
		components: {
			ManagingSection,
		},
		data() {
			return {
				total: 0,
				list: [],
				status: {
					READY: '진행대기',
					STARTED: '진행중',
					FINISHED: '진행완료',
				},
			};
		},
		created() {
			this.getList();
		},
		methods: {
			async getList() {
				try {
					const { data } = await this.$axiosAdmin2.get(
						`/api/operation/maintenances`
					);
					this.total = data.contentTotal;
					this.list = data.data.map(item => {
						return {
							...item,
							createdDate: moment(item.createdAt).format(
								'YYYY-MM-DD HH:mm'
							),
							startDate: moment(item.startAt).format(
								'YYYY-MM-DD HH:mm'
							),
							endDate: moment(item.endAt).format(
								'YYYY-MM-DD HH:mm'
							),
						};
					});
				} catch (error) {
					console.error(error);
					alert('서비스 점검 목록을 불러오는데 실패했습니다.');
				}
			},
			async deleteItem(id) {
				try {
					if (this.checkEnd(id)) {
						alert('종료된 서비스는 삭제할 수 없습니다.');
						return;
					}
					if (!confirm('삭제하시겠습니까?')) return;

					await this.$axiosAdmin2.delete(
						`/api/operation/maintenance?id=${id}`
					);
					alert('삭제되었습니다.');
					this.getList();
				} catch (error) {
					console.error(error);
					alert('삭제에 실패했습니다.');
				}
			},
			modifyItem(id) {
				this.$router.push(`/operation/service-check-modify/${id}`);
			},
			checkEnd(id) {
				return (
					this.list.find(item => item.id === id).status === 'FINISHED'
				);
			},
		},
	};
</script>
<style lang="scss" scoped></style>
